var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Nutze skilldoo 100% kostenfrei und anonym.")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "feature-list feature-list--tighter mb-5" },
      _vm._l(_vm.features, function(feature, i) {
        return _c(
          "li",
          { key: "feature" + i },
          [
            _c("Icon", { attrs: { icon: "checkmark" } }),
            _vm._v(" "),
            _c("span", {
              staticClass: "text",
              domProps: { innerHTML: _vm._s(feature) }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tag-sections" }, [
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { state: _vm.firstNameValid } },
                    [
                      _c("b-input", {
                        attrs: { placeholder: "Mein Vorname" },
                        on: { input: _vm.emitChangeEvent },
                        model: {
                          value: _vm.personalData.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.personalData, "firstName", $$v)
                          },
                          expression: "personalData.firstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.emailValid,
                        "invalid-feedback":
                          _vm.emailError && _vm.emailError.show
                            ? _vm.emailError.message
                            : undefined
                      }
                    },
                    [
                      _c("b-input", {
                        attrs: {
                          type: "email",
                          placeholder: "Meine E-Mail-Adresse"
                        },
                        on: { input: _vm.emitChangeEvent },
                        model: {
                          value: _vm.personalData.email,
                          callback: function($$v) {
                            _vm.$set(_vm.personalData, "email", $$v)
                          },
                          expression: "personalData.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "10" } },
                [
                  _c("Password", {
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("PrivacyCheckbox", {
            attrs: { "agb-short": "" },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.privacy,
              callback: function($$v) {
                _vm.privacy = $$v
              },
              expression: "privacy"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }